// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"e59b8154","453":"9537af23","565":"6bc79d34","587":"c2f1d1a2"}[chunkId] + ".chunk.js";
};